export default __webpack_public_path__ + "a7f4d496b3479a3231bcc4d60d8940a0.png";